import { createFormHook } from '@tanstack/react-form';

import { ResetButton, SubmitButton } from './submit.form.component';
import { FormTextField } from './text-field.form.component';
import { FormTextAreaField } from './textarea-field.form.component';
import { fieldContext, formContext } from './use-form.context';

const { useAppForm } = createFormHook({
  formContext,
  fieldContext,

  formComponents: {
    SubmitButton,
    ResetButton,
  },
  fieldComponents: {
    TextField: FormTextField,
    TextAreaField: FormTextAreaField,
  },
});

export { useAppForm };
